/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EdictRecordResponse
 */
export interface EdictRecordResponse {
    /**
     * 
     * @type {string}
     * @memberof EdictRecordResponse
     */
    sourceReference: string;
    /**
     * 
     * @type {string}
     * @memberof EdictRecordResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof EdictRecordResponse
     */
    caseNoteId: string;
    /**
     * 
     * @type {string}
     * @memberof EdictRecordResponse
     */
    assignmentId: string;
}

/**
 * Check if a given object implements the EdictRecordResponse interface.
 */
export function instanceOfEdictRecordResponse(value: object): value is EdictRecordResponse {
    if (!('sourceReference' in value) || value['sourceReference'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('caseNoteId' in value) || value['caseNoteId'] === undefined) return false;
    if (!('assignmentId' in value) || value['assignmentId'] === undefined) return false;
    return true;
}

export function EdictRecordResponseFromJSON(json: any): EdictRecordResponse {
    return EdictRecordResponseFromJSONTyped(json, false);
}

export function EdictRecordResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EdictRecordResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceReference': json['sourceReference'],
        'clientId': json['clientId'],
        'caseNoteId': json['caseNoteId'],
        'assignmentId': json['assignmentId'],
    };
}

export function EdictRecordResponseToJSON(json: any): EdictRecordResponse {
    return EdictRecordResponseToJSONTyped(json, false);
}

export function EdictRecordResponseToJSONTyped(value?: EdictRecordResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceReference': value['sourceReference'],
        'clientId': value['clientId'],
        'caseNoteId': value['caseNoteId'],
        'assignmentId': value['assignmentId'],
    };
}

